export class DropdownItemType {
  public static readonly REGULAR = 'dropdown-item-regular';
  public static readonly ENABLE = 'dropdown-item-enable';
  public static readonly DISABLE = 'dropdown-item-disable';
}
